import { CSSProperties, ReactNode } from "react";
import { FilterOptionOption } from "react-select/dist/declarations/src/filters";
import { MenuItems, MenuItem } from "./menu";

export const CONTROL_HEIGHT = {
  regular: "38px",
  large: "46px"
} as const;

export type FilterMultiSelectProps = {
  id: string;
  data?: MenuItems;
  value?: MenuItems;
  disabled?: boolean;
  placeholder?: string;
  onChange: (values: MenuItems) => void;
  containerClass?: string;
  containerStyle?: CSSProperties;
  isValidNewOption?: (inputValue: string) => boolean;
  onCreateOption?: (inputValue: string) => void;
  formatCreateLabel?: (inputValue: string) => ReactNode;
  filterOption?: (
    option: FilterOptionOption<MenuItem>,
    inputValue: string
  ) => boolean;
  onInputChange?: (inputValue: string) => ReactNode;
  noOptionsMessage?: (obj: { inputValue: string }) => ReactNode;
  isLoading?: boolean;
  height?: "regular" | "large";
  errorMsg?: string;
  isOptionDisabled?: () => boolean;
  customDisabledMessage?: string;
};
